import api from "Common/Client/Interceptor";

export const getAdminPaymentLedgerList = async (params = {}) => {
  try {
    const response = await api.get("/indv/LearnerPaymentLedger/Get-List", {
      params: {
        pageNumber: params.pageNumber || 1,
        pageSize: params.pageSize || 10,
        orderByLatest: params.orderByLatest || true,
        ...params
      }
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching admin payment ledger:", error);
    throw error;
  }
};

export const getPaymentLedgerById = async (id) => {
  try {
    const response = await api.get(`/indv/LearnerPaymentLedger/Get-By-Id/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching payment ledger by ID:", error);
    throw error;
  }
};

